var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36364 3.90854H2L9.50909 13.9213L2.40909 22.0904H4.81818L10.6255 15.4094L15.6364 22.0904H22L14.1745 11.6558L20.9091 3.90854H18.5L13.0582 10.1685L8.36364 3.90854ZM16.5455 20.2722L5.63636 5.72672H7.45455L18.3636 20.2722H16.5455Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterShare);
export default __webpack_public_path__ + "static/media/TwitterShare.e84c42992f74b7d3162c47b318fe9ca2.svg";
export { ForwardRef as ReactComponent };